import React from "react";

import Header from "../Header";
import Footer from "../Footer";

import { ReactComponent as Eye } from '../../assets/eye.svg';
import { ReactComponent as EditSvg } from '../../assets/edit.svg';
import { ReactComponent as EditPurple } from '../../assets/edit_purple.svg';
import { ReactComponent as Qrcode } from '../../assets/qrcode_small.svg';
import { ReactComponent as QrcodePurple } from '../../assets/qrcode_purple.svg';
import { ReactComponent as Remove } from '../../assets/remove.svg';
import { ReactComponent as Add } from '../../assets/add_black.svg';
import { ReactComponent as Cancel } from '../../assets/cancel.svg';

import questions from '../../assets/questions.png';
import video from '../../assets/video.png';
import download from '../../assets/download.png';
import profile from '../../assets/module_profile.png';

import questions_small from '../../assets/questions_small.png';
import video_small from '../../assets/video_small.png';
import download_small from '../../assets/download_small.png';
import profile_small from '../../assets/profile_small.png';


export default function Edit () {
    
    return (
        
        <div className="page page_project page_edit">
        
            <Header />
            
            <main>
                <div className="content">
                
                    <ul className="breadcrumbs">
                        <li>
                            <a href="/">Home</a>
                        </li>
                        <li>
                            <a href="/">Event</a>
                        </li>
                        <li>
                            <span>Event 1</span>
                        </li>
                    </ul>
                    
                    <div className="page__title">
                        <h1>Event 1</h1>        
                        <div className="title__buttons">
                            <div className="button check">
                                Publish
                            </div>
                            <div className="button_border test">
                                <Eye />
                                Test on device
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                    
                        <section className="section_event">
                            <div className="left">
                                <label>Enter project name</label>
                                <input placeholder="Name event" defaultValue="Event 1" />
                                
                                <div className="module">
                                    <div className="title">
                                        Module 1
                                        <div>
                                            <div className="edit"><EditSvg /></div>
                                            <div className="qrcode"><Qrcode /></div>
                                        </div>
                                    </div>
                                    <div className="bg_light">
                                    
                                        <div className="activity active">
                                            <div className="icon">
                                                <img src={questions} alt="" />
                                            </div>
                                            <div className="name active">
                                                Quiz
                                                <div className="icon edit"><EditPurple /></div>
                                            </div>
                                            <div className="icon qrcode"><QrcodePurple /></div>                                            
                                        </div>
                                        
                                        <div className="button button_add">Add new activity</div>

                                    </div>
                                </div>
                                
                                <div className="module">
                                    <div className="title">
                                        Module 2
                                        <div>
                                            <div className="edit"><EditSvg /></div>
                                            <div className="qrcode"><Qrcode /></div>
                                        </div>
                                    </div>
                                    <div className="bg_light">
                                    
                                            <div className="activity">
                                                <div className="icon">
                                                    <img src={video} alt="" />
                                                </div>
                                                <div className="name">
                                                    Video
                                                    <div className="icon edit"><EditPurple /></div>                                                
                                                </div>
                                                <div className="icon qrcode"><QrcodePurple /></div>
                                                <div className="move"></div>
                                            </div>
                                            <div className="activity">
                                                <div className="icon">
                                                    <img src={download} alt="" />
                                                </div>
                                                <div className="name">
                                                    Download
                                                    <div className="icon edit"><EditPurple /></div>                                                
                                                </div>
                                                <div className="icon qrcode"><QrcodePurple /></div>                                            
                                                <div className="move"></div>
                                            </div>
                                            <div className="activity">
                                                <div className="icon">
                                                    <img src={profile} alt="" />
                                                </div>
                                                <div className="name">
                                                    Profile input
                                                    <div className="icon edit"><EditPurple /></div>                                                
                                                </div>
                                                <div className="icon qrcode"><QrcodePurple /></div>                                            
                                                <div className="move"></div>
                                            </div>
                                            
                                        
                                        
                                        
                                        <div className="button button_add">Add new activity</div>
                                    </div>
                                </div>
                                
                                
                                <div className="button_light add_module">
                                    <Add />
                                    Add new module
                                </div>
                                <div className="button check save">
                                    Save
                                </div>
                            </div>
                            <div className="right">
                            
                                <div className="settings dashed-border"> 
                            
                                    <div className="title"> 
                                        <div>
                                            <div className="icon"><img src={questions} alt="" /></div>
                                            <div className="name">Settings Quiz</div>
                                        </div>
                                        <div>
                                            <div className="icon qrcode"><QrcodePurple /></div>
                                            <div className="icon remove"><Remove /></div>
                                        </div>
                                    </div>

                                    <label>Enter Quiz name</label>
                                    <input type="text" placeholder="Question for the quiz" />
                                    
                                    <div className="subtitle">Quiz question</div>
                                    <label>Enter question for the quiz</label>
                                    <input type="text" placeholder="Question for the quiz" />
                                    
                                    <div className="subtitle">Responses</div>
                                    <label>Enter responses</label>
                                    <input type="text" placeholder="Responses name 1" />
                                    
                                    <label>Enter responses</label>
                                    <input type="text" placeholder="Responses name 2" />
                                
                                    <div className="button_border add">
                                        <Add/>
                                        Add responses
                                    </div>
                                
                                    <div className="button check save">
                                        Save activity
                                    </div>
                                    
                                    <div className="cancel">
                                        <Cancel/>
                                        Cancel
                                    </div>
                                
                                </div>
                                
                            </div>
                        </section>
            
                        <div>
                            <section className="section_activities">
                                <h2>Preview</h2>
                                
                                <div className="preview">
                                    <div className="title">
                                        Activities
                                    </div>
                                    <div className="preview_content">
                                        <div className="subtitle">
                                            Module 1
                                        </div>
                                        <div className="modules">
                                            <div className="module module_single">
                                                <div className="image"><img src={questions_small} alt="" /></div>
                                                <div className="text">
                                                    <div className="name">Quiz</div>
                                                    <div className="points">+5 points</div>
                                                </div>
                                                <div className="button_module edit"></div>
                                            </div>
                                        </div>
                                        <div className="subtitle">
                                            Module 2
                                        </div>
                                        <div className="modules">
                                            <div className="module">
                                                <div className="image"><img src={video_small} alt="" /></div>
                                                <div className="text">
                                                    <div className="name">Video</div>
                                                    <div className="points">+5 points</div>
                                                </div>
                                                <div className="button_module edit"></div>
                                            </div>
                                            <div className="module">
                                                <div className="image"><img src={download_small} alt="" /></div>
                                                <div className="text">
                                                    <div className="name">Download</div>
                                                    <div className="points">+5 points</div>
                                                </div>
                                                <div className="button_module edit"></div>
                                            </div>
                                            <div className="module">
                                                <div className="image"><img src={profile_small} alt="" /></div>
                                                <div className="text">
                                                    <div className="name">Profile input</div>
                                                    <div className="points">+5 points</div>
                                                </div>
                                                <div className="button_module edit"></div>
                                            </div>
                                        </div>                                        
                                    </div>
                                    <div className="control">
                                        <div className="button_control home">Home</div>
                                        <div className="button_control game">Game</div>
                                        <div className="button_control qrcode"></div>
                                        <div className="button_control rating">Rating</div>
                                        <div className="button_control profile">Profile</div>
                                    </div>
                                </div>
                                
                                
                                
                            </section>
                            
                            <div className="unpublish">Unpublish</div>
                        
                        </div>
                        
                        
                    </div>

                </div>
            </main>
            
            <Footer />            
            
        </div>
    )
        
}

